export let ReferralInfo = /*#__PURE__*/function (ReferralInfo) {
  ReferralInfo["DASHBOARD_SETUP"] = "dashboard-setup";
  ReferralInfo["DASHBOARD_SETUP_WIDGET_DOMAIN"] = "dashboard-setup-widget-domain";
  return ReferralInfo;
}({});
//# sourceMappingURL=constants.js.map